import {useLocation} from "react-router-dom";

export const getQueryParam = (param, url) => {
	const urlParams = new URLSearchParams(url.search);
	return urlParams.get(param);
};

export const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};